module.exports = __webpack_public_path__ + "media/images/countryrect/bj-2858f9d9d99c7160792006d4d5286d01.svg";